import { getConfig } from "./featureSwitch";
import { Blocks as GenericBlocks } from "../../Generic/custom_components/components/block_renderer";
import { Blocks as AanZetBlocks } from "../../AanZet/custom_components/components/block_renderer";
import { Blocks as DeNieuweBibliotheekBlocks } from "../../DeNieuweBibliotheek/custom_components/components/block_renderer";
const blocksConfig = {
    vbp: GenericBlocks,
    aanzet: AanZetBlocks,
    bkw: GenericBlocks,
    dnb: DeNieuweBibliotheekBlocks,
    flevo: GenericBlocks,
    rdam: GenericBlocks,
    twente: GenericBlocks
};
const getLibraryBlocks = getConfig(blocksConfig);
export const Blocks = (props)=>getLibraryBlocks()(props);
